import styled from 'styled-components';
import {
  TranshipmentSuccessfullyCreated as TranshipmentSuccessfullyCreatedSVG,
  Title as DefaultTitle,
  Text,
} from '~components';

export const Title = styled(DefaultTitle)`
  margin-top: ${({ theme }) => theme.spacing.km10};
`;

export const TranshipmentSuccessfullyCreated = styled(
  TranshipmentSuccessfullyCreatedSVG
)`
  margin: ${({ theme }) => theme.spacing.km8} auto;
  margin-bottom: ${({ theme }) => theme.spacing.km0};
`;

export const Hr = styled.hr`
  width: 100%;
  margin: ${({ theme }) => theme.spacing.km0} auto;
  height: 1px;
  margin-top: ${({ theme }) => theme.spacing.km4};
  border-color: ${({ theme }) => theme.color.border.neutral.default};
`;

export const Description = styled(Text)`
  letter-spacing: -0.03em;
  margin-top: ${({ theme }) => theme.spacing.km2};
`;

export const TitleAccopany = styled(DefaultTitle)`
  font-size: ${({ theme }) => theme.font.size.m4};
  color: ${({ theme }) => theme.color.text.neutral.strong};
  font-weight: ${({ theme }) => theme.font.weight.bold};
  line-height: ${({ theme }) => theme.font.lineHeight.small};
  letter-spacing: -0.03em;
  margin-top: ${({ theme }) => theme.spacing.km4};
  margin-bottom: 0;
`;

export const DescriptionAcconpany = styled(Text)`
  letter-spacing: -0.03em;
  margin-top: ${({ theme }) => theme.spacing.km2};
`;

export const ContainerAlert = styled.div`
  margin-top: 84px;
`;
